import { render, staticRenderFns } from "./SalaryAdvanceRequest.vue?vue&type=template&id=f0b8d3ee&"
import script from "./SalaryAdvanceRequest.vue?vue&type=script&lang=js&"
export * from "./SalaryAdvanceRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports